import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-strikethrough w-4 h-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14 12a4 4 0 0 1 0 8H6" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "4",
  x2: "20",
  y1: "12",
  y2: "12"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }